import { Base } from '@studiometa/js-toolkit';

/**
 * ScrollToTop component
 */
export default class ScrollToTop extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'ScrollToTop',
    title: {
      type: String,
      default: 'Retour en haut',
    },
  };

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    if (y > window.innerHeight) {
      this.$el.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      this.$el.classList.add('opacity-0', 'pointer-events-none');
    }
  }

  /**
   * Click on element
   * @returns {void}
   */
  onClick() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }
}
